import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useSafeParams = () => {
	// eslint-disable-next-line no-restricted-syntax
	const { token, clientId } = useParams();

	return useMemo(
		() => ({
			token: token ? String(token) : undefined,
			clientId: clientId ? Number(clientId) : undefined,
		}),
		[clientId, token],
	);
};
